
import { Fragment, useEffect, useRef } from 'react';
import { useAppSelector } from '../../redux/hooks';
import { useNavigate } from 'react-router';

export interface IChallengeProps {
    challenge: string
}

function ThreeDSChallenge() {

    const paymentState = useAppSelector(state => state.payments);
    const navigate = useNavigate();
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!paymentState.redirectHtml) {
            console.warn('redirectHtml is not available, redirecting back to home');
            navigate('/');
            return;
        }

        if (containerRef.current) {
            containerRef.current.innerHTML = '';
            
            containerRef.current.innerHTML = paymentState.redirectHtml;

  
            setTimeout(() => {
                const scriptElement = document.getElementById('authenticate-payer-script');
                if (scriptElement && scriptElement.textContent) {
                    try {
                       
                        const newScript = document.createElement('script');
                        newScript.type = 'text/javascript';
                        newScript.async = true;
                        newScript.textContent = scriptElement.textContent;
                        document.head.appendChild(newScript); 

                        
                    } catch (error) {
                        console.error('Error executing 3DS authentication script:', error);
                    }
                } else {
                    console.warn('authenticate-payer-script element not found or has no content');
                }
            }, 0);
        }

    }, [paymentState.redirectHtml, navigate])

    // Show loading or fallback if redirectHtml is not available
    if (!paymentState.redirectHtml) {
        return (
            <Fragment>
                <div style={{ 
                    textAlign: 'center', 
                    padding: '50px',
                    minHeight: '50vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <p>Loading 3DS Challenge...</p>
                </div>
            </Fragment>
        );
    }

    return (
        <Fragment>
            <div 
                ref={containerRef}
                id="threedcontainer"
                style={{
                    width: '100%'
                }}
            />
        </Fragment>
    )
}

export default ThreeDSChallenge;